import React, { useCallback, useEffect, useState } from 'react'

import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalButton,
  SIZE,
  ROLE,
} from 'baseui/modal'
import { KIND as ButtonKind } from 'baseui/button'
import { styled } from 'baseui'
import { Select, Value } from 'baseui/select'
import { expandBorderStyles } from 'baseui/styles'
import DrawerSelect from 'components/Select/DrawerSelect'
import Checkbox, {
  LABEL_PLACEMENT,
  STYLE_TYPE,
} from 'components/CheckBox/CheckBox'

export interface ConfirmationOptions {
  catchOnCancel?: boolean
  variant: 'danger' | 'info'
  title: string
  description: string
  selectionOptions?: Array<selectionOptions> | undefined | null
}

interface ConfirmationDialogProps extends ConfirmationOptions {
  open: boolean
  onSubmit: (value) => any
  onClose: () => void
}

interface selectionOptions {
  id: number
  label: string
  color: string
}

export const FeaturedSelectModal: React.FC<ConfirmationDialogProps> = ({
  open,
  title,
  variant,
  description,
  selectionOptions,
  onSubmit,
  onClose,
}) => {
  // console.log("We have selection options ->", selectionOptions);
  const [value, setValue] = useState(null)

  const [featured, setFeatured] = useState(true)

  // Reset modal value...
  useEffect(() => {
    setValue(null)
  }, [open])

  useEffect(() => {
    setValue(featured)
  }, [featured])

  return (
    <Modal
      onClose={onClose}
      closeable
      isOpen={open}
      animate
      autoFocus
      size={SIZE.default}
      role={ROLE.dialog}
      overrides={{
        Root: {
          style: {
            zIndex: 100,
          },
        },
      }}
    >
      <ModalHeader>{title}</ModalHeader>
      <ModalBody>
        <p>{description}</p>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            borderTop: '1px solid #eee',
            borderBottom: '1px solid #eee',
          }}
        >
          <p>
            Setting Value:{' '}
            <strong>{featured ? 'YES (TRUE)' : 'NO (FALSE)'}</strong>{' '}
          </p>
          <Checkbox
            checked={featured}
            checkmarkType={STYLE_TYPE.toggle_round}
            onChange={(e) => {
              e.stopPropagation()
              setFeatured(!featured)
            }}
            labelPlacement={LABEL_PLACEMENT.left}
            overrides={{
              Root: {
                style: {
                  float: 'right',
                  // marginRight: "20px"
                },
              },
            }}
          />
        </div>
      </ModalBody>
      <ModalFooter>
        {variant === 'danger' && (
          <>
            <ModalButton
              kind={ButtonKind.tertiary}
              onClick={onClose}
              overrides={{
                BaseButton: {
                  style: ({ $theme }) => ({
                    color: $theme.colors.red400,
                  }),
                },
              }}
            >
              Cancel
            </ModalButton>
            <ModalButton
              onClick={(e) => onSubmit(value)}
              disabled={!value} // IF selection component and no value, then disabled...
              overrides={{
                BaseButton: {
                  style: ({ $theme }) => ({
                    backgroundColor: $theme.colors.red400,
                  }),
                },
              }}
            >
              Yes
            </ModalButton>
          </>
        )}

        {variant === 'info' && (
          <ModalButton onClick={(e) => onSubmit(value)}>OK</ModalButton>
        )}
      </ModalFooter>
    </Modal>
  )
}

// ===== Adding colors to selector ===
const ColorSwatch = styled('div', (props: any) => {
  return {
    width: props.$theme.sizing.scale500,
    height: props.$theme.sizing.scale500,
    marginRight: props.$theme.sizing.scale200,
    display: 'inline-block',
    backgroundColor: props.$color,
    verticalAlign: 'baseline',
    ...expandBorderStyles(props.$theme.borders.border400),
  }
})
const getLabel = ({ option }: any) => {
  return (
    <React.Fragment>
      {option.color ? <ColorSwatch $color={option.color} /> : null}
      {option.label}
    </React.Fragment>
  )
}
